import styled from 'styled-components';

/**
 * The "N other Damages at this point" line describes the plotted point rather
 * than the Damage listed below it, so it reads as a caption separated from the
 * attribute list. Colors come from the tooltip tokens because the tooltip
 * surface is dark navy in both themes.
 */
export const OtherDamagesCaption = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.tooltipDividerColor};
  color: ${({ theme }) => theme.tooltipTextColor};
  font-size: 1em;
  font-style: italic;
  margin-bottom: 0.5rem;
  padding-bottom: 0.35rem;
  font-weight: 600;
`;
